<template>
  <div class="title-view">
    <h3>
      <van-icon :name="icon" />
      {{name}}
    </h3>
  </div>
</template>

<script>
  import { Icon } from "vant";
  export default {
    name: "titleView",
    components: {
      [Icon.name]: Icon
    },
    props: ["name", "icon"]
  };
</script>

<style lang="scss">
  .title-view {
    height: 75%;
    line-height: 75px;
    h3 {
      font-size: 18px;
      text-align: center;
    }
  }
</style>